export const UPDATE_LOADER = 'LOADER/UPDATE';
